import { render, staticRenderFns } from "./DialogMergeAccount.vue?vue&type=template&id=19067093&scoped=true"
import script from "./DialogMergeAccount.vue?vue&type=script&lang=js"
export * from "./DialogMergeAccount.vue?vue&type=script&lang=js"
import style0 from "./DialogMergeAccount.vue?vue&type=style&index=0&id=19067093&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19067093",
  null
  
)

export default component.exports